import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance'; // Your axios instance
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import LoadingTable from '../../components/LoadingTable';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import LoadingScreen from '../../components/LoadingScreen';

// Register chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function IncomeAnalytics() {
  const [data, setData] = useState(null); // Store chart data
  const [loading, setLoading] = useState(true);

  // Fetch data from API
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/get-all-analytics`);
      setData(response.data.data.chartData); // Store chart data
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

 

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">All Analytics</h1>
            </div>
          </div>
        </div>

        <div className="card">
          {loading ? <LoadingScreen/> :
          <div className="table-responsive py-4">
            <div className="chart-container">
              {/* Render chart here */}
              {data && (
                <Bar
                  data={data}  // chartData from the response
                  options={{
                    responsive: true,
                    plugins: {
                      title: {
                        display: true,
                        text: 'Income Analytics by Category',
                      },
                      tooltip: {
                        mode: 'index',
                        intersect: false,
                      },
                    },
                    scales: {
                      x: {
                        title: {
                          display: true,
                          text: 'Categories',
                        },
                      },
                      y: {
                        title: {
                          display: true,
                          text: 'Income Earned',
                        },
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              )}
            </div>
          </div>
          }
          
        </div>
      </main>
    </>
  );
}

export default IncomeAnalytics;
